export enum MessageType {
    REGULAR = 'REGULAR',
    MANDATORY = 'MANDATORY',
    LEGAL_NOTIFICATION = 'LEGAL_NOTIFICATION',
}

export enum MessageState {
    DRAFT = 'DRAFT',
    SENT = 'SENT',
    RECEIVED = 'RECEIVED',
}

export enum MessageDocumentActionType {
    Payment = 'BETALING',
    SelfService = 'SELVBETJENING',
    Information = 'INFORMATION',
    Signature = 'UNDERSKRIV',
    Confirmation = 'BEKRAEFT',
    Preparation = 'FORBEREDELSE',
    Registration = 'TILMELDING',
    Reservation = 'AFTALE',
}
